var exports = {
  "GY": "cardContainerStyles__Gt0Saz",
  "bq": "imageContainerStyles__7kpbYL",
  "Wr": "templateImageStyles__J6ybkz",
  "lW": "templateInfoStyles__DQQx4p",
  "pQ": "Box_4__IfseUZ",
  "ws": "Box_5__NFMY9D",
  "D6": "Box_6__Iq5nDq",
};

module.exports = exports;
